import appSlice from './slice';

export const { setIsOnline, setLanguageCode, setBackgroundWorker, setIsSupervisorMode, setLockedProject } = appSlice.actions;

export default appSlice.reducer;
